import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-top, margin, padding"} maskId="square-filled-radius-0-stroke-1-IconLayoutTop"><path d="M21 6V21H3V6H21Z" fill="currentColor"/><path d="M21 3V4H3V3H21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutTop;
